module.exports = __webpack_public_path__ + "img/4.b2027ca1.jpg";